//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import { getPageKey, getCacheName, createPageHost, selectCachedViews } from '@/utils/pageCache';
export default {
  name: 'AppMain',
  data: function data() {
    return {
      cacheAccessOrder: [getPageKey(this.$route)]
    };
  },
  computed: {
    cacheEpoch: function cacheEpoch() {
      return this.$store.state.tagsView.cacheEpoch;
    },
    cacheNames: function cacheNames() {
      var _this = this;
      if (this.$store.state.app.device === 'mobile' || !this.$store.state.settings.tagsView) return [];
      // Old noCache form routes keep their drafts. Only explicitly disposable
      // pages are subject to the small LRU budget.
      return selectCachedViews(this.$store.state.tagsView.visitedViews, this.$route, this.cacheAccessOrder).map(function (v) {
        return _this.nameFor(v);
      });
    },
    hostKey: function hostKey() {
      return this.nameFor(this.$route);
    }
  },
  watch: {
    $route: function $route(to, from) {
      var _this2 = this;
      this.scrollPositions[getPageKey(from)] = this.$el.scrollTop;
      var key = getPageKey(to);
      this.cacheAccessOrder = this.cacheAccessOrder.filter(function (item) {
        return item !== key;
      }).concat(key);
      this.$nextTick(function () {
        _this2.$el.scrollTop = _this2.scrollPositions[key] || 0;
        _this2.pruneHosts();
      });
    },
    cacheNames: function cacheNames() {
      this.pruneHosts();
    }
  },
  created: function created() {
    this.hosts = Object.create(null);
    this.scrollPositions = Object.create(null);
  },
  methods: {
    pruneHosts: function pruneHosts() {
      var _this3 = this;
      var names = this.cacheNames;
      Object.keys(this.hosts).forEach(function (key) {
        if (names.indexOf(key) === -1 && key !== _this3.hostKey) delete _this3.hosts[key];
      });
      var keys = this.$store.state.tagsView.visitedViews.map(getPageKey);
      var accessOrder = this.cacheAccessOrder.filter(function (key) {
        return keys.indexOf(key) !== -1 || key === getPageKey(_this3.$route);
      });
      if (accessOrder.length !== this.cacheAccessOrder.length) this.cacheAccessOrder = accessOrder;
      Object.keys(this.scrollPositions).forEach(function (key) {
        if (keys.indexOf(key) === -1) delete _this3.scrollPositions[key];
      });
    },
    resolveHost: function resolveHost(key) {
      if (!this.hosts[key]) this.hosts[key] = createPageHost(Vue, key);
      return this.hosts[key];
    },
    nameFor: function nameFor(route) {
      var version = this.$store.state.tagsView.cacheVersions[getPageKey(route)] || 0;
      return getCacheName(route) + '_e' + this.cacheEpoch + '_v' + version;
    }
  }
};